import { create } from 'zustand';

// compactSettings의 상세 구조를 위한 인터페이스
export interface CompactSettings {
	infoSection?: boolean;    // 예: 정보 섹션 컴팩트 모드 여부
	tableSection?: boolean;   // 예: 테이블 섹션 컴팩트 모드 여부
	sidebar?: boolean;        // 예: 사이드바 컴팩트 모드 여부
}

export interface ScreenStore {

	//브라우저의 가로세로 길이
	screenWidth: number; setScreenWidth: (screenWidth: number) => void;
	screenHeight: number; setScreenHeight: (screenHeight: number) => void;

	tabDivFloorHeight: number; setTabDivFloorHeight: (tabDivFloorHeight: number) => void;

	//탭 디비 너비, 높이
	tabDivWidth: number; setTabDivWidth: (tabDivWidth: number) => void;
	tabDivHeight: number; setTabDivHeight: (tabDivHeight: number) => void;

	tabWidth: number; setTabWidth: (tabWidth: number) => void;
	tabHeight: number; setTabHeight: (tabHeight: number) => void;

}

const useScreenStore = create<ScreenStore>((set) => ({

	screenWidth: 0,
	setScreenWidth: (screenWidth: number) => set((state) => { return { ...state, screenWidth } }),
	screenHeight: 0,
	setScreenHeight: (screenHeight: number) => set((state) => { return { ...state, screenHeight } }),

	tabDivFloorHeight: 27,
	setTabDivFloorHeight: (tabDivFloorHeight: number) => set((state) => { return { ...state, tabDivFloorHeight } }),

	tabDivWidth: 300,
	setTabDivWidth: (tabDivWidth: number) => set((state) => { return { ...state, tabDivWidth } }),
	tabDivHeight: 0,
	setTabDivHeight: (tabDivHeight: number) => set((state) => { return { ...state, tabDivHeight } }),

	tabWidth: 140,
	setTabWidth: (tabWidth: number) => set((state) => { return { ...state, tabWidth } }),
	tabHeight: 25,
	setTabHeight: (tabHeight: number) => set((state) => { return { ...state, tabHeight } }),

}));

export default useScreenStore;